import { render } from "./Cod8Page.vue?vue&type=template&id=3facd549&scoped=true"
import script from "./Cod8Page.vue?vue&type=script&lang=js"
export * from "./Cod8Page.vue?vue&type=script&lang=js"

import "./Cod8Page.vue?vue&type=style&index=0&id=3facd549&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3facd549"]])

export default __exports__